import { render, staticRenderFns } from "./NewPolicy.vue?vue&type=template&id=0008b3fa"
import script from "./NewPolicy.vue?vue&type=script&lang=js"
export * from "./NewPolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports